import { action, thunk } from "easy-peasy";
import { fetchBanner } from "../../services/banner";

export const bannerModel = {
  picture: null,
  blur: "0px",
  error: null,
  setError: action((state, payload) => {
    state.error = payload;
  }),
  setPicture: action((state, payload) => {
    state.picture = payload;
  }),
  setBlur: action((state, payload) => {
    state.blur = payload;
  }),
  getBanner: thunk(async (actions, payload) => {
    try {
      const request = await fetchBanner();
      if (request && !request.error) {
        if (request?.blur) actions.setBlur(request?.blur);
        if (request?.img) actions.setPicture(request?.img.url);
      }
    } catch (err) {
      actions.setError(err);
    }
  }),
};
